export default "__VITE_ASSET__CbvpXhSp__"